/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../types.tsx';
import { get } from './get/index.tsx';

export const actions: {
	get: (projectId: string, properties: string[]) => Action<State>;
} = { get };
